import { LayoutDashboard, Package, ShoppingCart, Store } from 'lucide-react';

export const navItems = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboard,
    to: '/dashboard',
    requiredRoles: ['buyer', 'seller'],
  },
  {
    id: 'cart',
    label: 'Cart',
    icon: ShoppingCart,
    to: '/cart',
    requiredRoles: ['buyer'],
  },
  {
    id: 'inventories',
    label: 'Inventory',
    icon: Package,
    to: '/buyer-inventory',
    requiredRoles: ['buyer'],
  },
  {
    id: 'orders',
    label: 'Orders',
    icon: Package,
    to: '/orders',
    requiredRoles: ['buyer', 'seller'],
  },
  {
    id: 'explore-products',
    label: 'Explore Products',
    icon: Store,
    to: '/explore-products',
    requiredRoles: ['buyer'],
  },
  {
    id: 'my-products',
    label: 'My Products',
    icon: Package,
    to: '/my-products',
    requiredRoles: ['seller'],
  },
];
